import PropTypes from 'prop-types';
import React from 'react';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import PhoneNumber from '../../components/phoneNumber.jsx';

class CustomerTable extends React.Component {
  static displayName = 'CustomerTable';

  static propTypes = {
    customers: PropTypes.array.isRequired,
    contactIDs: PropTypes.array,
    intl: intlShape.isRequired,
  };

  customerClick = (id) => {
    window.location.hash = `#customer/${id}`;
  };

  render() {
    let {formatMessage} = this.props.intl;
    let customerRows = this.props.customers.filter(x => !x.AccountNo || x.CustomerContacts && x.CustomerContacts.length > 0).map((customer, index) => {
      // If it is a duplicate search, clean up the results

      if (customer.AccountNo) {
        let contact = customer.CustomerContacts[0] || {};
        // if (this.props.contactIDs[index]) {
        //   contact = customer.CustomerContacts.find(x => x.ID === this.props.contactIDs[index]);
        // }

        customer.cId = customer.ID;
        customer.accountNo = customer.AccountNo;
        customer.name = contact.NameFirst + ' ' + contact.NameLast;
        customer.name = customer.name.trim();
        customer.organization = customer.Organization;
        customer.inactive = customer.Inactive;
        customer.address1 = customer.Address1;
        customer.email = contact.Email;
        customer.homePhone = contact.HomePhone;
        customer.fav = customer.Favourite;
        customer.flag = customer.Flag;
      }

      let star;
      let flag;

      if (customer.truBlueActive) {
        star = <i className='bl bl-tru-blue-filled fa-lg blue' title={formatMessage({id: 'trublue.raindrop.status.active'})} />;
      } else if (customer.truBlueInactive || customer.truBlueEligible || customer.truBlueOpportunity) {
        star = <i className='bl bl-tru-blue-filled fa-lg grey' title={`${customer.truBlueInactive ? formatMessage({id: 'trublue.raindrop.status.inactive'}) :
          customer.truBlueEligible ? formatMessage({id: 'trublue.raindrop.status.eligible'}) :
          formatMessage({id: 'trublue.raindrop.status.opportunity'})}`} />;
      } else if (customer.fav) {
        star = <i key={index + 'star'} className='bl bl-star-filled fa-lg star' title={formatMessage({id: 'general.preferred.customer'})} />;
      }

      if (customer.flag) {
        flag = <i key={index + 'flag'} className='bl bl-flag-filled fa-lg flagged' title={customer.flagTitle} />;
      }

      let displayName;

      if (customer && customer.name && typeof customer.name === 'string' && customer.name.trim().length === 0) {
        displayName =
          <td className='search-of'>
            <span style={{fontWeight: '600'}}>{customer.organization} {customer.inactive ? '(' + formatMessage({id: 'general.inactive'}) + ')' : ''}</span>
          </td>
        ;
      } else {
        displayName =
          <td className='search-of'>
            <span style={{fontWeight: '600'}}>{customer.name} {customer.inactive ? '(' + formatMessage({id: 'general.inactive'}) + ')' : ''}</span>
            <br/>
            {customer.organization}
          </td>
        ;
      }

      return (
        <tr key={index} className={customer.inactive ? 'inactive' : ''} onClick={this.customerClick.bind(this, customer.Id || customer.ID)}>
          <td style={{paddingLeft: '10px'}}>
            {flag}{star}
          </td>
          <td>
            {customer.accountNo}
          </td>
          {displayName}
          <td className='search-of'>
            {customer.address1}
          </td>
          <td className='search-of'>
            {customer.email}
          </td>
          <td className='search-of'>
            <PhoneNumber>{customer.homePhone}</PhoneNumber>
          </td>
        </tr>
      );
    });

    return (
      <table className='table table-striped table-hover table-biolab hoverClick'>
        <thead>
          <tr>
            <th style={{width: '9%', paddingLeft: '10px'}}/>
            <th style={{width: '10%'}}><FormattedMessage id="general.account" /></th>
            <th style={{width: '23%'}}><FormattedMessage id="customer.search.customer.table" /></th>
            <th style={{width: '23%'}}><FormattedMessage id="general.address" /></th>
            <th style={{width: '20%'}}><FormattedMessage id="general.email" /></th>
            <th style={{width: '15%'}}><FormattedMessage id="general.phone.number" /></th>
          </tr>
        </thead>
        <tbody>
          {customerRows}
          {(() => {
            if ((this.props.customers || []).length === 0) {
              return (
                <tr key='-1'>
                  <td colSpan='100%'><i><FormattedMessage id="general.error.nomatches" /></i></td>
                </tr>
              );
            }
            return <tr key='-1'/>;
          })()}
        </tbody>
      </table>);
  }
}

export default injectIntl(CustomerTable);
